<div id="error-page-container">
    <div id="text-container">
        <h1 class="title">{{ 'serverErrorPage.title' | translate }}</h1>

        <div class="content">
            <p>{{ 'serverErrorPage.content.firstSentence' | translate }}</p>
            <p>
                <i>{{ 'serverErrorPage.content.secondSentence' | translate }}</i>
            </p>
            <p>
                <span [innerHtml]="'serverErrorPage.content.thirdSentence' | translate"></span
                ><a href="tel: 888-321-2113" class="link">888-321-2113</a>.
            </p>
        </div>

        <div class="action-buttons">
            <btn
                id="go-to-dashboard-btn"
                [label]="'serverErrorPage.backToDashboard.button.text'"
                [severity]="'primary'"
                [size]="'large'"
                (onClick)="goToDashboard()"></btn>
            <btn
                id="sign-out-btn"
                [label]="'profileMenu.signOut'"
                [severity]="'primary'"
                [outlined]="true"
                [size]="'large'"
                (onClick)="logout()"></btn>
        </div>
    </div>

    <div id="image-container">
        <img src="images/illustrations/error_500.svg" alt="server-error-image" />
    </div>
</div>
